export enum UAEntityTypes {
  Interface = 'e_interface',
  Component = 'e_component',
  DataSource = 'e_data_source',
  Blocks = 'e_blocks',
  CustomBlock = 'e_custom_component',
  CustomIcon = 'e_icon_registry',
  DeployedCustomIcon = 'e_icon_registry_deployed',
  InterfaceNamespace = 'e_i18n_namespace',
  InterfaceOverride = 'e_interface_override',
  DeployedInterface = 'e_interface_deployed',
  DeployedComponent = 'e_component_deployed',
  DeployedDataSource = 'e_data_source_deployed',
  DeployedInterfaceNamespace = 'e_i18n_namespace_deployed',
  InterfaceBaseDomain = 'e_interface_base_domain',
  User = 's_user',
  APIEndpoint = 's_api_endpoint',
  APIEndpointCollection = 's_api_endpoint_collection',
  APIPolicyType = 's_api_policy_type',
  APIAccessProfile = 's_api_access_profile',
  RuntimeEnvironment = 's_remote_runtime_env',
  PlatformAutomation = 'platform_automation',
  ChangeType = 'CHANGE_TYPE',
  FilterDetailsType = 'CONNECTOR_OBJECT_NAME',
  SnippetLanguageType = 'SNIPPET_LANGUAGE',
  IdentityProvider = 's_identity_provider',
  PlatformBackupConnectionConfig = 's_backup_connection_config',
  NodeBuilder = 'NODE_BUILDER',
  WalkthroughSession = 'e_walkthrough_session',
  AgentSettings = 'e_ai_agent_settings',

  /**
   * This entity gives the name, pluralName of all the modules.
   * Use this entity to get the name of the module. Don't hardcode the module name in code.
   */
  Modules = 'e_platform_module',

  /**
   * This entity gives the application side navigation items.
   */
  Navigation = 'e_platform_navigation',

  NotificationCategory = 'e_notification_category',
  NotificationEventType = 'e_notification_event_type',
  NotificationGroup = 'e_notification_group',

  AlertModule = 'e_alert_module',
  AlertModuleGroup = 'e_alert_module_group',
  AlertMetric = 'e_alert_metric',
  AlertDimension = 'e_alert_dimension',
  AlertGroupByMetric = 'e_alert_group_by_metric',
  CodeSnippet = 'e_code_snippet',

  ApplicationPageTemplates = 'e_page_template',
  DataSourceTemplates = 'e_data_source_template',
  Dataset = 'dataset',
  ExternalAiAgentTraces = 'e_external_ai_agent_traces',

  EventStandardEntity = 'e_calendar_event',
  UserActivityTracking = 'e_user_activity',

  // Timeline Block Standard Entity
  TimelineEventsStandardEntity = 'e_timeline_events',

  Theme = 'e_theme',

  TextToLowCodeApplicationProgress = 'text_to_low_code_application_progress',
  TextToWorkflowGenerationProgress = 'text_to_workflow_progress',
  ServiceHubMessage = 'service_hub_message',
}

export enum LookupTypes {
  ApplicationByName = 'APPLICATION_BY_NAME',
  AIAgent = 'ENTITY_ID:ai_agent',
  AIAgentAuthor = 'ENTITY_ID:ai_agent_people',
  Component = 'ENTITY_ID:e_component',
  CustomerProfile = 'ENTITY_ID:customer_profile',
  NodeBuilderByName = 'NODE_BUILDER_BY_NAME',
  WorkflowCallableInterface = 'WORKFLOW_CALLABLE_INTERFACE',
  ServiceHubCase = 'ENTITY_ID:service_hub_case',
}
